import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';

export default function PrivacyPolicy() {
  return (
    <>
      <SEOHead
        title="Privacy Policy — LitBuy Spreadsheet"
        description="This Privacy Policy explains how litbuyspreadsheets.one handles your information when you visit our website. We do not collect personal data, use tracking cookies, or deploy analytics scripts."
        canonicalPath="/privacy-policy"
        pageType="website"
        breadcrumbData={[
          { name: 'Home', path: '/' },
          { name: 'Privacy Policy', path: '/privacy-policy' },
        ]}
      />
      <Navbar />
      <main className="min-h-screen">
        <div className="bg-background-100 py-14 md:py-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-500 transition-colors">Home</Link>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Privacy Policy</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Privacy Policy
            </h1>
            <p className="mt-4 text-foreground-600 text-base leading-relaxed max-w-2xl">
              Last updated: June 2026. This Privacy Policy explains how litbuyspreadsheets.one handles your information when you visit our website.
            </p>
          </div>
        </div>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Information We Do Not Collect</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              LitBuy Spreadsheet Resource Center is designed as an informational resource. We do not require users to create accounts, and we do not collect personal information such as names, email addresses, or phone numbers through the normal use of our website.
            </p>
            <p className="text-foreground-700 leading-relaxed">
              We do not use cookies for tracking purposes, and we do not deploy analytics scripts that identify individual users. Your browsing activity on this site remains private.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">External Links</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              Our website contains links to external websites, primarily kaspreadsheet.com. Please be aware that we are not responsible for the privacy practices of these other sites. When you leave litbuyspreadsheets.one, we encourage you to read the privacy statements of each website that collects personally identifiable information.
            </p>
            <p className="text-foreground-700 leading-relaxed">
              All external links on this website are marked with the appropriate rel=&quot;noopener nofollow&quot; attributes to protect your privacy and security when navigating away from our site.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Children&apos;s Privacy</h2>
            <p className="text-foreground-700 leading-relaxed">
              Our website is intended for a general audience and does not knowingly collect any personal information from children under the age of 13. If you believe that a child has provided personal information through our site, please contact us so we can take appropriate action.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Changes to This Policy</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Any changes will be posted on this page with an updated revision date.
            </p>
            <p className="text-foreground-700 leading-relaxed">
              We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information. Your continued use of the website after any changes constitutes your acceptance of the updated policy.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Contact Information</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              If you have questions about this Privacy Policy or our data practices, please visit our main website for contact information.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit kaspreadsheet.com
              <i className="ri-arrow-right-line"></i>
            </a>
          </section>
        </article>
      </main>
      <Footer />
    </>
  );
}